<template>
  <section class="diagnosis-running-card mb-4">
    <h3 class="diagnosis-running-card__title">Your diagnosis is running</h3>
    <p v-if="summary" class="diagnosis-running-card__line">{{ summary }}</p>
    <p class="diagnosis-running-card__line">Findings will show here as they finish. You can leave this page.</p>
  </section>
</template>

<script>
export default {
  name: 'DiagnosisRunningCard',
  props: {
    providerCount: {
      type: Number,
      default: 0
    },
    matchStringCount: {
      type: Number,
      default: 0
    },
    dismissals: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // Mentions only what is known: a count, or a step the user skipped.
    summary() {
      const parts = []
      if (this.providerCount > 0) {
        parts.push(`Includes ${this.providerCount} ${this.providerCount === 1 ? 'provider' : 'providers'}.`)
      } else if (this.dismissals?.providers) {
        parts.push('Providers were skipped.')
      }
      if (this.matchStringCount > 0) {
        parts.push(`Uses ${this.matchStringCount} brand match ${this.matchStringCount === 1 ? 'string' : 'strings'}.`)
      } else if (this.dismissals?.match_strings) {
        parts.push('Brand match strings were skipped.')
      }
      return parts.join(' ')
    }
  }
}
</script>

<style scoped>
.diagnosis-running-card {
  background: #ffffff;
  border: 1px solid var(--brand-sand-300);
  border-radius: 16px;
  padding: 20px 24px;
}

.diagnosis-running-card__title {
  font-family: 'Lora', serif;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--brand-ink-950);
  margin: 0 0 6px;
}

.diagnosis-running-card__line {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.6;
  color: rgba(13, 36, 64, 0.62);
}
</style>
